/**
 * This file is kept for backward compatibility and to avoid updating every import in the Web app.
 * All new analytics-related code should live in and be imported directly from "@punchup/analytics".
 */

import {
  getMixpanelDistinctId as _getMixpanelDistinctId,
  identifyUser as _identifyUser,
  resetAnalytics as _resetAnalytics,
  trackEvent as _trackEvent,
} from "@punchup/analytics";

/**
 * @deprecated import from "@punchup/analytics" package instead
 */
export const trackEvent = _trackEvent;

/**
 * @deprecated import from "@punchup/analytics" package instead
 */
export const identifyUser = _identifyUser;

/**
 * @deprecated import from "@punchup/analytics" package instead
 */
export const resetAnalytics = _resetAnalytics;

/**
 * @deprecated import from "@punchup/analytics" package instead
 */
export const getMixpanelDistinctId = _getMixpanelDistinctId;
